import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useTranslation } from '@/i18n';
import { Button } from '@/components/Shared/Button';
import { useNetzplanImportStore, type WizardStep } from '@/store/useNetzplanImportStore';

interface Props {
  back?: WizardStep;
  next?: WizardStep;
  /** Extra summary text shown between the buttons (e.g. "12 werden angelegt"). */
  summary?: string;
}

export function StepFooter({ back, next, summary }: Props) {
  const { t } = useTranslation('import');
  const setStep = useNetzplanImportStore((s) => s.setStep);
  return (
    <div className="flex items-center justify-between gap-3 pt-2">
      <div>
        {back && (
          <Button variant="secondary" leftIcon={<ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} />} onClick={() => setStep(back)}>
            {t('actions.back')}
          </Button>
        )}
      </div>
      <div className="flex items-center gap-3">
        {summary && <span className="text-[12px] text-slate-500">{summary}</span>}
        {next && (
          <Button rightIcon={<ArrowRight className="w-3.5 h-3.5" strokeWidth={2} />} onClick={() => setStep(next)}>
            {t('actions.next')}
          </Button>
        )}
      </div>
    </div>
  );
}

export default StepFooter;
